module.exports = __webpack_public_path__ + "img/virado_header_4.b7468627.jpg";